import { Component, effect, ElementRef, inject, input, viewChild } from "@angular/core";
import { MediaService } from "@services";

@Component({
  selector: 'app-troll-compass',
  templateUrl: './compass.component.html',
  styleUrls: ['./compass.component.scss'],
  imports: [
  ]
})
export class TrollCompassComponent {
  mediaService = inject(MediaService);

  compassRef = viewChild.required<ElementRef<HTMLCanvasElement>>("compass");
  degrees = input.required<number[]>();

  width = input<number>(400);
  height = input<number>(400);

  constructor() {
    effect(() => {
      const themeColors = this.mediaService.themeColors();
      const canvas = this.compassRef().nativeElement;
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        console.error("failed to get drawing context");
        return;
      }

      const width = this.width();
      const height = this.height();

      const centerX = width / 2;
      const centerY = height / 2;
      const radius = Math.min(width, height) / 2 - 50; // compass ring radius

      ctx.clearRect(0, 0, width, height);

      // scale the canvas to avoid blurriness
      canvas.width = width * window.devicePixelRatio;
      canvas.height = height * window.devicePixelRatio;
      canvas.style.width = width + "px";
      canvas.style.height = height + "px";
      ctx.scale(window.devicePixelRatio, window.devicePixelRatio);

      // lines
      ctx.strokeStyle = themeColors.border;
      ctx.lineCap = "round";
      ctx.lineWidth = 0.5;
      ctx.beginPath();
      // vertical
      ctx.moveTo(centerX, centerY - radius);
      ctx.lineTo(centerX, centerY + radius);
      // horizontal
      ctx.moveTo(centerX - radius, centerY);
      ctx.lineTo(centerX + radius, centerY);
      ctx.stroke();

      ctx.strokeStyle = themeColors.border
        .replace("rgb(", "rgba(")
        .replace(")", ", 0.33)");;

      // NW to SE
      ctx.moveTo(centerX - radius, centerY - radius);
      ctx.lineTo(centerX + radius, centerY + radius);
      // NE to SW
      ctx.moveTo(centerX + radius, centerY - radius);
      ctx.lineTo(centerX - radius, centerY + radius);
      ctx.stroke();

      // outer circle
      // ctx.beginPath();
      // ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
      // ctx.strokeStyle = strokeColor;
      // ctx.lineWidth = 2;
      // ctx.stroke();

      // labels
      ctx.fillStyle = themeColors.text;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.font = "bold 16px Roboto";
      ctx.fillText('N', centerX, centerY - radius - 12);
      ctx.fillText('S', centerX, centerY + radius + 12);
      ctx.fillText('E', centerX + radius + 12, centerY);
      ctx.fillText('W', centerX - radius - 12, centerY);

      // compass needle
      const needles = this.degrees();
      for (let i = 0; i < needles.length; i++) {
        const degrees = needles[i];
        const needleLength = i === 0 ? radius / 2 : radius;
        const radians = (degrees - 90) * (Math.PI / 180);
        const tipX = centerX + needleLength * Math.cos(radians);
        const tipY = centerY + needleLength * Math.sin(radians);

        // needle
        ctx.strokeStyle = i === 0 ? themeColors.primary : themeColors.error;
        ctx.lineWidth = 3;
        ctx.beginPath();
        ctx.moveTo(centerX, centerY);
        ctx.lineTo(tipX, tipY);
        ctx.stroke();

        // center dot
        ctx.fillStyle = themeColors.primary;
        ctx.beginPath();
        ctx.arc(centerX, centerY, 4, 0, 2 * Math.PI);
        ctx.fill();
      }
    });
  }
}
